<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" style="min-height: 500px;">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="closeModal"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div class="mt-3 text-center sm:mt-0 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                {{ transEdit('lock-day') }} {{date}}
              </h3>
            </div>
            <!--
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label for="lock-modal-temp" class="block text-sm font-medium text-gray-700">
                  {{ transEdit('info-about-substitute') }}
                </label>
                <div class="mt-1">
                <textarea
                    id="lock-modal-temp"
                    rows="3"
                    class="shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
                </div>
              </div>
            </div>
            -->
            <div class="pt-4">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                {{ transEdit('reporting') }}
              </h3>
              <p class="mt-1 text-sm text-gray-500">
                {{ transEdit('therapist-lock-reminder') }}
              </p>
              <!--
              <div class="sm:col-span-6 pt-4">
                <label for="lock-modal-comment" class="block text-sm font-medium text-gray-700">
                  {{ transEdit('comment') }}
                </label>
                <div class="mt-1">
                <textarea
                    id="lock-modal-comment"
                    rows="3"
                    class="shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
                </div>
              </div>
              -->
            </div>
          </div>
          <div class="pt-5">
            <div class="flex justify-end">
              <button type="button" @click="closeModal"
                      class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{ transEdit('cancel') }}
              </button>
              <button type="submit" @click="lockDay"
                      class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-tlmblue2 hover:bg-tlmblue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{ transEdit('lock-day') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "therapist-dash-modal-lock",
  props: ['route_lock', 'date'],
  methods: {
    lockDay: function () {
      let self = this;
      let thisModal = $("#lock-modal");
      let reportText = $("#lock-modal-comment").val();
      let tempText = $("#lock-modal-temp").val();

      axios.post(this.$portalUrl(self.route_lock), {
        date: this.date,
        tempInfo: tempText,
        comment: reportText,
      })
          .then(function (response) {
            self.$emit('close');
          })
          .catch(function (error) {
          });

      thisModal.modal('toggle');
    },
    closeModal() {
      this.$emit('close');
    },
  }
}
</script>

<style scoped>

</style>
